import React from "react";
import { InputGroup, Input, InputLeftElement, Icon } from "@chakra-ui/react";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LocationSearchFilterProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
}

export const LocationSearchFilter: React.FC<LocationSearchFilterProps> = ({
  searchTerm,
  onSearchChange,
  placeholder,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "locations",
  });

  const searchPlaceholder = placeholder || (t("searchPlaceholder") as string);

  return (
    <InputGroup maxW="400px">
      <InputLeftElement pointerEvents="none">
        <Icon as={Search} color="gray.400" />
      </InputLeftElement>
      <Input
        placeholder={searchPlaceholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        bg="white"
        color="gray.600"
        border="1px solid"
        borderColor="gray.200"
        _focus={{
          borderColor: "newBlue.500",
          boxShadow: "0 0 0 1px #1E5297",
        }}
      />
    </InputGroup>
  );
};
